import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Button, Modal, Card } from 'antd';
import { SpButton } from '../../../design';

const Waiverdocs = (props: Props) => {
  const { id } = useParams();
  const abc = atob(id);

  useEffect(() => {
    const pdfUrl = abc;
    const iframe = document.getElementById('pdfIframe');
    iframe.src = pdfUrl;
  }, []); 

  const iframeStyle = {
    width: '100%', 
    height: '100%', 
    border: '1px solid black',
  };

 


  const handleClick = () => {
    
    localStorage.setItem('waiverDocApproved', true);
    window.close();
  };

  const handleClickClose = () => {
    
    
    window.close();
  };

  

  const buttonStyle = {
    borderRadius: '4px',
    backgroundColor: 'white', 
    color: 'black', 
    border: '1px solid rgba(0, 0, 0, 0.2)', 
    padding: '16px 24px'
  };

  return (
    <div style={{ width: '100%', height: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
     <br/>  <iframe id="pdfIframe" title="Waiver Docs" style={iframeStyle} />
<div style={{display:"flex" , gap:"12px"}}>

        <SpButton  onClick={handleClickClose}>Cancel</SpButton>
        
<SpButton style={{backgroundColor:"#007bff" , color:"#fff"}}  onClick={handleClick} type="secondary">Confirm Consent</SpButton>
        

</div>
      
    </div>
  );
};

export default Waiverdocs;
